module.exports = __webpack_public_path__ + "img/market-share.6a44b9b0.svg";